/**
 * URL de base de l'API Symfony.
 * Doit se terminer par /api (ex: http://localhost:8000/api).
 */
export function getApiBaseUrl() {
  const raw = process.env.REACT_APP_API_URL || process.env.API_URL || 'http://localhost:8000/api';
  const trimmed = raw.replace(/\/+$/, '');

  if (trimmed.endsWith('/api')) {
    return trimmed;
  }

  return `${trimmed}/api`;
}
